<template>
<div class="lh-root" :style="themePageStyle">

  <nav class="lh-topbar"><div class="container d-flex align-items-center justify-content-between py-2">
    <div class="d-flex align-items-center" style="gap:12px;">
      <a href="javascript:void(0)" @click="$router.push('/')"><img src="assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;">Learning Hub</span>
    </div>
    <div class="d-flex gap-2">
      <button class="btn btn-sm btn-outline-warning" @click="$router.push('/forum')"><i class="mdi mdi-forum me-1"></i>Forum</button>
      <button class="btn btn-sm btn-warning" @click="$router.push('/marketplace')"><i class="mdi mdi-storefront-outline me-1"></i>Marketplace</button>
    </div>
  </div></nav>

  <div class="container lh-container">

    <!-- Hero -->
    <div class="text-center mb-4">
      <h4 class="fw-bold" style="color:var(--fm-h,#F5F0E8);">📚 Livestock Learning Hub</h4>
      <p style="color:var(--fm-s,#6B6356);font-size:13px;max-width:640px;margin:0 auto;">
        Practical guides on dairy farming, poultry, animal health, breeding and market trends — written for Kenyan farmers.
      </p>
    </div>

    <!-- Filters -->
    <div class="lh-filters">
      <div class="input-group" style="max-width:420px;">
        <span class="input-group-text lh-addon"><i class="mdi mdi-magnify"></i></span>
        <input v-model="search" class="form-control lh-input" placeholder="Search articles..." @keyup.enter="loadArticles" />
      </div>
      <button class="btn btn-sm btn-outline-warning ms-2" @click="loadArticles"><i class="mdi mdi-filter-variant"></i></button>
    </div>

    <!-- Categories chips -->
    <div class="d-flex gap-2 mb-4 flex-wrap">
      <button class="lh-chip" :class="{active: !filter.categorySlug}" @click="filter.categorySlug=''; loadArticles()">All</button>
      <button v-for="c in categories" :key="c.id" class="lh-chip"
              :class="{active: filter.categorySlug === c.slug}"
              @click="filter.categorySlug = filter.categorySlug === c.slug ? '' : c.slug; loadArticles()">
        {{ c.name }}
      </button>
    </div>

    <!-- Featured row -->
    <div v-if="featured.length" class="mb-4">
      <h6 style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-star me-1" style="color:#FFD700;"></i>Featured</h6>
      <div class="row g-3">
        <div class="col-md-6 col-lg-4" v-for="a in featured" :key="'f-'+a.id">
          <div class="lh-card lh-card-feat" @click="openArticle(a)">
            <div class="lh-cover" :style="a.cover_image_url ? 'background-image:url(' + imgUrl(a.cover_image_url) + ')' : ''">
              <i v-if="!a.cover_image_url" class="mdi mdi-book-open-variant"></i>
              <span class="lh-aud">{{ humanize(a.target_audience) }}</span>
            </div>
            <div class="lh-body">
              <span class="lh-cat">{{ a.category_name }}</span>
              <div class="lh-title">{{ a.title }}</div>
              <p class="lh-excerpt">{{ a.excerpt }}</p>
              <div class="lh-meta">
                <span><i class="mdi mdi-eye-outline me-1"></i>{{ a.view_count }}</span>
                <span><i class="mdi mdi-heart me-1"></i>{{ a.like_count }}</span>
                <span v-if="a.published_at"><i class="mdi mdi-calendar me-1"></i>{{ a.published_at.split(' ')[0] }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- All articles -->
    <h6 style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-book-multiple me-1" style="color:#BFA164;"></i>All articles</h6>
    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>
    <div v-else-if="!articles.length" class="text-center py-5">
      <i class="mdi mdi-book-search-outline" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
      <h5 class="mt-3" style="color:var(--fm-h,#F5F0E8);">No articles match</h5>
      <p style="color:var(--fm-s,#6B6356);">Try a different category or search term.</p>
    </div>
    <div v-else class="row g-3">
      <div class="col-md-6 col-lg-4" v-for="a in articles" :key="a.id">
        <div class="lh-card" @click="openArticle(a)">
          <div class="lh-cover" :style="a.cover_image_url ? 'background-image:url(' + imgUrl(a.cover_image_url) + ')' : ''">
            <i v-if="!a.cover_image_url" class="mdi mdi-book-open-variant"></i>
            <span class="lh-aud">{{ humanize(a.target_audience) }}</span>
          </div>
          <div class="lh-body">
            <span class="lh-cat">{{ a.category_name }}</span>
            <div class="lh-title">{{ a.title }}</div>
            <p class="lh-excerpt">{{ a.excerpt }}</p>
            <div class="lh-meta">
              <span><i class="mdi mdi-eye-outline me-1"></i>{{ a.view_count }}</span>
              <span><i class="mdi mdi-heart me-1"></i>{{ a.like_count }}</span>
              <span v-if="a.published_at"><i class="mdi mdi-calendar me-1"></i>{{ a.published_at.split(' ')[0] }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
</template>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important}
html[data-theme="light"] .lh-root{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .lh-topbar{background:rgba(255,255,255,.95)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .lh-card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .lh-input,
html[data-theme="light"] .lh-addon,
html[data-theme="light"] .lh-chip{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#555!important}
</style>

<style scoped>
.lh-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh;color:var(--fm-h,#F5F0E8)}
.lh-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.lh-container{padding-top:80px;padding-bottom:60px;max-width:1100px}
.lh-filters{display:flex;align-items:center;margin-bottom:14px}
.lh-input{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);color:var(--fm-h,#F5F0E8)!important;font-size:13px}
.lh-addon{background:var(--fm-bg2,#0F0F0F)!important;border-color:var(--fm-br,#1E1E1E)!important;color:var(--fm-s,#6B6356)!important}
.lh-chip{padding:6px 14px;border-radius:20px;border:1px solid var(--fm-br,#1E1E1E);background:var(--fm-bg1,#141414);color:var(--fm-m,#A09888);font-size:12px;cursor:pointer;transition:all .2s}
.lh-chip:hover{border-color:#BFA164;color:#BFA164}
.lh-chip.active{background:rgba(191,161,100,.1);border-color:#BFA164;color:#BFA164;font-weight:600}

.lh-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;overflow:hidden;cursor:pointer;transition:all .2s;height:100%;display:flex;flex-direction:column}
.lh-card:hover{border-color:#BFA164;transform:translateY(-2px)}
.lh-card-feat{border-color:rgba(255,215,0,.3)}
.lh-cover{height:140px;background:var(--fm-bg2,#0F0F0F);display:flex;align-items:center;justify-content:center;font-size:42px;color:var(--fm-s,#3A3530);position:relative;background-size:cover;background-position:center}
.lh-aud{position:absolute;top:8px;right:8px;background:rgba(0,0,0,.6);color:#FFD700;font-size:10px;padding:2px 8px;border-radius:6px;text-transform:uppercase;letter-spacing:.4px}
.lh-body{padding:14px;display:flex;flex-direction:column;flex:1}
.lh-cat{display:inline-block;font-size:10px;padding:2px 8px;border-radius:6px;background:rgba(191,161,100,.1);color:#BFA164;margin-bottom:6px;font-weight:600;text-transform:uppercase;letter-spacing:.3px}
.lh-title{color:var(--fm-h,#F5F0E8);font-weight:700;font-size:14px;line-height:1.4;margin-bottom:6px}
.lh-excerpt{color:var(--fm-m,#A09888);font-size:12px;line-height:1.5;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;flex:1;margin-bottom:8px}
.lh-meta{display:flex;gap:10px;font-size:10px;color:var(--fm-s,#6B6356);padding-top:8px;border-top:1px dashed var(--fm-br,#1E1E1E);margin-top:auto}
</style>

<script>
/* eslint-disable */
import { executeJson, flocker, uploads } from "@/api";

export default {
  name: "LearningHub",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,loading:false,search:'',
    filter: { categorySlug:'' },
    categories: [], articles: [], featured: []
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'}
  },
  mounted(){
    this._applyThemeOnce();
    var self=this;
    this.themeObserver=new MutationObserver(function(){try{self._applyThemeOnce();}catch(e){}});
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    this.loadCategories();
    this.loadFeatured();
    this.loadArticles();
  },
  beforeUnmount(){if(this.themeObserver){this.themeObserver.disconnect();this.themeObserver=null}},
  methods:{
    _applyThemeOnce(){
      var current=document.documentElement.getAttribute('data-theme');
      var desired=(localStorage.getItem('flockr_theme')||current||'dark');
      if(current!==desired) document.documentElement.setAttribute('data-theme',desired);
      this.darkMode=desired!=='light';
    },
    imgUrl(u){if(!u)return'';if(u.indexOf('http')===0)return u;return uploads+String(u).replace(/^uploads\//,'');},
    humanize(s){return (s||'').charAt(0).toUpperCase()+ (s||'').slice(1);},
    async loadCategories(){
      try{var r=await executeJson({function:'getArticleCategories'},flocker);
        if(r.data&&r.data.success) this.categories=(r.data.data&&r.data.data.categories)||[];
      }catch(e){}
    },
    async loadFeatured(){
      try{var r=await executeJson({function:'getArticles',featuredOnly:1,limit:3},flocker);
        if(r.data&&r.data.success) this.featured=(r.data.data&&r.data.data.articles)||[];
      }catch(e){}
    },
    async loadArticles(){
      this.loading=true;
      try{
        var params={function:'getArticles',limit:30};
        if(this.filter.categorySlug) params.categorySlug=this.filter.categorySlug;
        if(this.search) params.search=this.search;
        var r=await executeJson(params,flocker);
        if(r.data&&r.data.success) this.articles=(r.data.data&&r.data.data.articles)||[];
      }catch(e){console.error(e)}
      this.loading=false;
    },
    openArticle(a){this.$router.push('/learn/'+(a.slug||a.id))}
  }
};
</script>
